var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrovo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    baseProfile: "basic",
    viewBox: "0 0 117.643 116.249",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#32c27c",
    d: "M104.629 82.328c-2.023-8.102-8.09-13.51-16.636-13.445-8.366.064-13.01 5.381-13.635 11.275-.46 4.346 1.199 7.835 3.606 9.262 4.426 2.624 7.533-1.846 5.809-3.504-1.11-1.068-1.625-1.972-1.383-3.588s1.477-3.233 4.39-3.233 5.368 2.082 5.891 6.39c.617 5.083-2.727 10.587-8.626 11.834-7.469 1.579-15.003-2.407-17.673-8.826s-1.945-16.427 4.441-22.548c5.059-4.849 11.607-6.635 17.18-6.635l18.645.818c1.38.061 2.612-.858 2.948-2.198l7.97-32.513c.058-.231.087-.469.087-.708 0-1.606-1.117-2.908-2.723-2.908H80.83c-.11 0-.22-.012-.328-.037-.782-.181-1.27-.962-1.089-1.744L83.22 3.562c.05-.215.075-.435.075-.655C83.295 1.302 81.994 0 80.388 0h-35.28c-1.971 0-3.698 1.322-4.211 3.226l-3.892 16.427c-.342 1.269-1.494 2.15-2.808 2.15H11.6c-2.041 0-3.808 1.415-4.256 3.405L.071 57.547c-.047.21-.071.424-.071.639 0 1.606 1.302 2.908 2.908 2.908h23.167c.143 0 .284.014.424.042 1.182.234 1.949 1.382 1.715 2.563-.687 3.469-1.149 6.899-1.385 10.29-.702 10.081 1.942 21.12 9.898 29.739 13.539 14.667 38.532 15.518 53.319 7.37 11.89-6.553 17.119-18.618 14.583-28.77"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrovo);
export default __webpack_public_path__ + "static/media/trovo.d5899d43225996cb793846069e4543fb.svg";
export { ForwardRef as ReactComponent };